import debounce from "debounce";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextInput from "../../../../components/inputs/textInput/TextInput";
import Loader from "../../../../components/loader/Loader";
import SettingsPagesContainer from "../../../../components/settingsPagesContainer/SettingsPagesContainer";
import {
  fetchUsersByQuery,
  resetSearchResults,
  updateResultsFromCache,
} from "../../../../features/userSearch/userSearchSlice";
import OneUser from "../allUsers/oneUser/OneUser";
import styles from "./searchForUser.module.css";

const SearchForUser = () => {
  const [query, setQuery] = useState("");
  const dispatch = useDispatch();
  const { cache, results, status } = useSelector((state) => state.userSearch);

  const debouncedSearch = useRef(null);

  useEffect(() => {
    debouncedSearch.current = debounce((value) => {
      if (!value) {
        dispatch(resetSearchResults());
        return;
      }

      const cacheKey = `user:${value}`;

      if (cache[cacheKey]) {
        dispatch(updateResultsFromCache(cache[cacheKey]));
      } else {
        dispatch(fetchUsersByQuery({ query: value, kind: "user" }));
      }
    }, 500);

    return () => {
      if (debouncedSearch.current && debouncedSearch.current.cancel) {
        debouncedSearch.current.cancel();
      }
    };
  }, [dispatch, cache]);

  const handleSearch = useCallback((e) => {
    const value = e.target.value;
    setQuery(value);

    if (debouncedSearch.current) {
      debouncedSearch.current(value);
    }
  }, []);

  return (
    <SettingsPagesContainer title={"البحث عن لاعب"}>
      <div className={styles.searchInputWrapper}>
        <TextInput
          height="50px"
          width="400px"
          borderRadius="10px"
          placeHolder="البحث عن لاعب عن طريق الاسم او الايدي"
          bgColor={"grey"}
          bordered={true}
          value={query}
          onChange={(e) => handleSearch(e)}
        />
      </div>
      {status === "loading" ? (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      ) : (
        results?.length > 0 &&
        results?.map((item) => {
          return (
            <OneUser
              name={item?.name}
              email={item?.email}
              region={item?.region}
              userImage={item?.userImage}
              addedTime={item?.createdAt}
              modifiedTime={item?.updatedAt}
              key={item._id}
              userId={item._id}
              banned={item?.banned}
              gameIds={item?.gameIds}
            />
          );
        })
      )}
    </SettingsPagesContainer>
  );
};

export default SearchForUser;
